export interface StorageService {
  getItem(key: string): Promise<string | null>;
  setItem(key: string, value: string): Promise<void>;
  removeItem(key: string): Promise<void>;
  clear(): Promise<void>;
  getAllKeys(): Promise<string[]>;
  multiGet(keys: string[]): Promise<Array<[string, string | null]>>;
  multiSet(keyValuePairs: Array<[string, string]>): Promise<void>;
  multiRemove(keys: string[]): Promise<void>;
}

export class StorageHelpers {
  constructor(private storage: StorageService) {}

  async getJSON<T>(key: string): Promise<T | null> {
    try {
      const value = await this.storage.getItem(key);
      return value ? JSON.parse(value) : null;
    } catch (error) {
      console.error(`[Storage] Error parsing JSON for key "${key}":`, error);
      return null;
    }
  }

  async setJSON<T>(key: string, value: T): Promise<void> {
    try {
      const stringified = JSON.stringify(value);
      await this.storage.setItem(key, stringified);
    } catch (error) {
      console.error(`[Storage] Error stringifying JSON for key "${key}":`, error);
      throw error;
    }
  }

  async has(key: string): Promise<boolean> {
    const value = await this.storage.getItem(key);
    return value !== null;
  }

  async getWithDefault(key: string, defaultValue: string): Promise<string> {
    const value = await this.storage.getItem(key);
    return value ?? defaultValue;
  }

  async getJSONWithDefault<T>(key: string, defaultValue: T): Promise<T> {
    const value = await this.getJSON<T>(key);
    return value ?? defaultValue;
  }
}
